export const yandexDataCheckModalName = 'yandex-data-check-modal';
